module.exports = __webpack_public_path__ + "img/平板1.2a7c692f.jpg";